import {
  registerCommentsWidget as publicRegisterCommentsWidget,
  queryCommentsWidgetResources as publicQueryCommentsWidgetResources,
  createCommentsWidget as publicCreateCommentsWidget,
  getCommentsWidget as publicGetCommentsWidget,
  updateCommentsWidget as publicUpdateCommentsWidget,
  deleteCommentsWidget as publicDeleteCommentsWidget,
  queryCommentsWidget as publicQueryCommentsWidget,
  typedQueryCommentsWidget as publicTypedQueryCommentsWidget,
} from './comments-categories-v1-comments-widget-widgets.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  CommentsWidgetQuery,
  CommentsWidgetsQueryBuilder,
  typedQueryCommentsWidget as universalTypedQueryCommentsWidget,
} from './comments-categories-v1-comments-widget-widgets.universal.js';
import { onCommentsWidgetCreated as publicOnCommentsWidgetCreated } from './comments-categories-v1-comments-widget-widgets.public.js';
import { onCommentsWidgetDeleted as publicOnCommentsWidgetDeleted } from './comments-categories-v1-comments-widget-widgets.public.js';
import { onCommentsWidgetUpdated as publicOnCommentsWidgetUpdated } from './comments-categories-v1-comments-widget-widgets.public.js';

function customQueryCommentsWidget(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryCommentsWidget(httpClient)(),
    typedQueryFunction: (query: CommentsWidgetQuery) =>
      publicTypedQueryCommentsWidget(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): CommentsWidgetsQueryBuilder;
  function overloadedQuery(
    query: CommentsWidgetQuery
  ): ReturnType<typeof universalTypedQueryCommentsWidget>;
  function overloadedQuery(query?: CommentsWidgetQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const registerCommentsWidget: MaybeContext<
  BuildRESTFunction<typeof publicRegisterCommentsWidget> &
    typeof publicRegisterCommentsWidget
> = /*#__PURE__*/ createRESTModule(publicRegisterCommentsWidget);
export const queryCommentsWidgetResources: MaybeContext<
  BuildRESTFunction<typeof publicQueryCommentsWidgetResources> &
    typeof publicQueryCommentsWidgetResources
> = /*#__PURE__*/ createRESTModule(publicQueryCommentsWidgetResources);
export const createCommentsWidget: MaybeContext<
  BuildRESTFunction<typeof publicCreateCommentsWidget> &
    typeof publicCreateCommentsWidget
> = /*#__PURE__*/ createRESTModule(publicCreateCommentsWidget);
export const getCommentsWidget: MaybeContext<
  BuildRESTFunction<typeof publicGetCommentsWidget> &
    typeof publicGetCommentsWidget
> = /*#__PURE__*/ createRESTModule(publicGetCommentsWidget);
export const updateCommentsWidget: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCommentsWidget> &
    typeof publicUpdateCommentsWidget
> = /*#__PURE__*/ createRESTModule(publicUpdateCommentsWidget);
export const deleteCommentsWidget: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCommentsWidget> &
    typeof publicDeleteCommentsWidget
> = /*#__PURE__*/ createRESTModule(publicDeleteCommentsWidget);
export const queryCommentsWidget: MaybeContext<
  BuildRESTFunction<typeof customQueryCommentsWidget> &
    typeof customQueryCommentsWidget
> = /*#__PURE__*/ createRESTModule(customQueryCommentsWidget);
/** */
export const onCommentsWidgetCreated: BuildEventDefinition<
  typeof publicOnCommentsWidgetCreated
> &
  typeof publicOnCommentsWidgetCreated = createEventModule(
  publicOnCommentsWidgetCreated
);
/** */
export const onCommentsWidgetDeleted: BuildEventDefinition<
  typeof publicOnCommentsWidgetDeleted
> &
  typeof publicOnCommentsWidgetDeleted = createEventModule(
  publicOnCommentsWidgetDeleted
);
/** */
export const onCommentsWidgetUpdated: BuildEventDefinition<
  typeof publicOnCommentsWidgetUpdated
> &
  typeof publicOnCommentsWidgetUpdated = createEventModule(
  publicOnCommentsWidgetUpdated
);

export {
  SortOrder,
  WebhookIdentityType,
} from './comments-categories-v1-comments-widget-widgets.universal.js';
export {
  CommentsWidget,
  RegisterCommentsWidgetRequest,
  RegisterCommentsWidgetResponse,
  QueryCommentsWidgetResourcesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryCommentsWidgetResourcesResponse,
  CursorPagingMetadata,
  Cursors,
  CreateCommentsWidgetRequest,
  CreateCommentsWidgetResponse,
  GetCommentsWidgetRequest,
  GetCommentsWidgetResponse,
  UpdateCommentsWidgetRequest,
  UpdateCommentsWidgetResponse,
  DeleteCommentsWidgetRequest,
  DeleteCommentsWidgetResponse,
  QueryCommentsWidgetRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Paging,
  QueryCommentsWidgetResponse,
  PagingMetadataV2,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CommentsWidgetCreatedEnvelope,
  CommentsWidgetDeletedEnvelope,
  CommentsWidgetUpdatedEnvelope,
  RegisterCommentsWidgetOptions,
  UpdateCommentsWidget,
  DeleteCommentsWidgetOptions,
  CommentsWidgetsQueryResult,
  CommentsWidgetsQueryBuilder,
  CommentsWidgetQuerySpec,
} from './comments-categories-v1-comments-widget-widgets.universal.js';
export { utils } from './comments-categories-v1-comments-widget-widgets.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  CommentsWidgetQuery,
} from './comments-categories-v1-comments-widget-widgets.universal.js';
